import React, { useEffect } from "react";
import { Spinner } from "react-bootstrap";
import { connect } from "react-redux";
import Layout from "../../components/Shared/Layout/Layout";

import DashboardProductList from "../../components/DashboardProductList/DashboardProductList";
import { getProductList } from "../../actions/Book.action";

const DashboardPage = ({ data, getProductList }) => {
  useEffect(() => {
    if (data === null) {
      getProductList();
    }
  }, []);
  return (
    <Layout title="Dashboard">
      {data === null ? (
        <Spinner animation="grow" variant="dark" />
      ) : (
        <>
          <DashboardProductList product={data} />
        </>
      )}
    </Layout>
  );
};

const mapStateToProps = (state) => ({
  data: state.product.product,
});

export default connect(mapStateToProps, { getProductList })(DashboardPage);
